/**
 * ReportsCtrl controller
 *
 * @class ReportsCtrl
 * @memberof mwApp/reports
 * @see mwApp/reports
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/reports.controller:ReportsCtrl
 */
/* @ngInject */
export default function ReportsCtrl ($scope, authSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('createSubscriberReport')
    ? [['tabsCtrlMixin', '', 'reports_list', 'generated_reports']]
    : [['tabsCtrlMixin', '']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/reports.controller:ReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
